import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.linkedin.com/in/mrraaz/"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-linkedin"></i>
      </a>

      <a
        href="https://twitter.com/home"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-twitter"></i>
      </a>

      <a
        href="https://github.com/Mr-raaz"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-github"></i>
      </a>
    </div>
  );
};

export default Social;
